/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_5_DescInputs */

const en_mk_feature_5_desc = /** @type {(inputs: Mk_Feature_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with local business templates or continue from an existing project and documents.`)
};

const id_mk_feature_5_desc = /** @type {(inputs: Mk_Feature_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari template usaha lokal atau lanjutkan dari proyek dan dokumen yang sudah ada.`)
};

/**
* | output |
* | --- |
* | "Start with local business templates or continue from an existing project and documents." |
*
* @param {Mk_Feature_5_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_5_desc = /** @type {((inputs?: Mk_Feature_5_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_5_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_5_desc(inputs)
	return en_mk_feature_5_desc(inputs)
});